module.exports = __webpack_public_path__ + "img/sc.61f3eafa.png";